import fetch from 'isomorphic-unfetch'
import localStorage from 'localStorage'
import Router from 'next/router'

const API_ROOT_REMOTE = process.env.NEXT_PUBLIC_API_URL
// const API_ROOT_REMOTE = 'http://192.168.31.136:8082'
// const API_ROOT_REMOTE = 'https://api.gd.lingti.com'
const API_GO_ROOT_REMOTE = process.env.NEXT_PUBLIC_GO_API_URL
// export const API_GO_ROOT_REMOTE = 'http://192.168.31.136:3002'

const DEVICE_TYPE = 'WEB_LINGTI'
const NETWORK_ERROR_MESSAGE = '网络请求失败，请检查网络连接或服务状态'

const networkErrorResponse = (method: string, url: string, error: unknown) => {
  // Avoid logging query parameters because they may contain user data or login codes.
  console.error(`[request] ${method} ${url.split('?')[0]} failed`, error)
  return {
    ok: false,
    error: 'network_error',
    message: NETWORK_ERROR_MESSAGE,
  }
}

export const setToken = (s) => {
  return localStorage.setItem(`Token`, s)
}
export const getToken = () => {
  return localStorage.getItem('Token')
}

export const clearToken = () => {
  return localStorage.removeItem('Token')
}

const headers = () => {
  return {
    // 'Access-Control-Allow-Origin': '*',
    Authorization: getToken(),
    // 'Access-Control-Allow-Methods': 'OPTIONS, GET, POST, PUT, PATCH, DELETE',
    Accept: 'application/json',
    'Content-Type': 'application/json',
  }
}

const body = (data) => {
  return {
    DEVICE_TYPE,
    ...data,
  }
}

const parseResponse = async (res) => {
  if (res.headers.get('Authorization')) {
    setToken(res.headers.get('Authorization'))
  }
  try {
    const json = await res.json()
    if (res.status >= 400) {
      json.status = res.status
    }
    if (json.error === 'revoked token' || res.status === 401) {
      if (!json.message) {
        json.message = json.error
      }
      clearToken()

      // 修复401跳转逻辑
      const currentPath = Router.asPath

      // 如果当前已经在登录页面，则不需要重定向
      if (currentPath.includes('/login')) {
        return json
      }

      // 投屏大屏(/tp、/presentation)是公开页面,常年挂在未登录/凭证过期的电视浏览器上;
      // 任何一个后台请求 401 都不该把整块大屏劫持到扫码登录页(用户反馈「投屏打开需要扫码」)。
      if (currentPath.startsWith('/tp/') || currentPath.startsWith('/presentation/') || /^\/club\/[^/]+\/screen/.test(currentPath)) {
        return json
      }

      // 在线游戏路径处理
      if (currentPath.startsWith('/online_game')) {
        Router.replace(`/online_game/login?redirect=${encodeURIComponent(currentPath)}`)
      }
      // 普通路径处理
      else {
        Router.replace(`/login?redirect=${encodeURIComponent(currentPath)}`)
      }
    }
    return json
  } catch (error) {
    console.error(error)
  }
  return false
}

export const get = async (path, data = {}, isAbsolute = false) => {
  const params = body(data)
  const query = Object.keys(params)
    .map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
    .join('&')
  const remote = path.startsWith('machines') ? API_GO_ROOT_REMOTE : API_ROOT_REMOTE
  const url = isAbsolute ? `${path}?${query}` : `${remote}/${path}?${query}`
  let res
  try {
    res = await fetch(url, {
      method: 'GET',
      headers: headers(),
    })
  } catch (error) {
    return networkErrorResponse('GET', url, error)
  }
  return parseResponse(res)
}

const requestMethod =
  (method) =>
  async (path, data = {}, isAbsolute = false) => {
    const url = isAbsolute ? path : `${API_ROOT_REMOTE}/${path}`
    let res
    try {
      res = await fetch(url, {
        method,
        headers: headers(),
        body: JSON.stringify(body(data)),
      })
    } catch (error) {
      return networkErrorResponse(method, url, error)
    }
    const content = (await parseResponse(res)) || {}
    if (!content.ok && !content.message) {
      content.message = '操作失败,请重试或联系系统管理员'
    }
    return content
  }

const requestStreamMethod =
  (method) =>
  async (path, data, onReceiveData, setLoading, isAbsolute = false) => {
    const url = isAbsolute ? path : `${API_ROOT_REMOTE}/${path}`
    let res
    try {
      res = await fetch(url, {
        method,
        headers: headers(),
        body: JSON.stringify(body(data)),
      })
    } catch (error) {
      setLoading(false)
      return networkErrorResponse(method, url, error)
    }

    if (res.headers.get('Authorization')) {
      setToken(res.headers.get('Authorization'))
    }

    const reader = res.body.getReader()
    const decoder = new TextDecoder()
    let result = ''
    let isFirstUpdate = true

    const readStream = async () => {
      const { done, value } = await reader.read()
      if (done) return // 读取完成
      result += decoder.decode(value, { stream: true })
      if (isFirstUpdate) {
        setLoading(false)
        isFirstUpdate = false
      }

      /* eslint-disable no-constant-condition */
      try {
        // 尝试解析 JSON
        while (true) {
          const endIndex = result.indexOf('}\n') // 假设每个 JSON 对象以 '}' 结束并换行
          if (endIndex !== -1) {
            const jsonString = result.slice(0, endIndex + 1) // 提取完整的 JSON 字符串
            const jsonData = JSON.parse(jsonString) // 解析 JSON
            onReceiveData(jsonData.data) // 处理接收到的数据
            result = result.slice(endIndex + 1) // 更新 result，去除已解析部分
          } else {
            break // 没有找到完整的 JSON，退出循环
          }
        }
      } catch (error) {
        console.error('解析错误:', error)
      }
      /* eslint-enable no-constant-condition */

      await readStream() // 递归调用
    }

    try {
      await readStream() // 启动流读取
      return JSON.parse(result) // 返回JSON
    } catch (error) {
      console.error('流处理错误:', error)
    }

    return false
  }

export const post = requestMethod('POST')
export const put = requestMethod('PUT')
export const httpDelete = requestMethod('DELETE')
export const patch = requestMethod('PATCH')
export const postStream = requestStreamMethod('POST')

export const postForm = async (path: string, form: FormData) => {
  form.append('DEVICE_TYPE', DEVICE_TYPE)
  const url = `${API_ROOT_REMOTE}/${path}`
  let res
  try {
    res = await fetch(url, {
      method: 'POST',
      headers: { Authorization: getToken() } as any,
      body: form,
    })
  } catch (error) {
    return networkErrorResponse('POST', url, error)
  }
  return parseResponse(res)
}
